import { useOrgContext } from 'app/orgProvider'
import { useNavigate } from 'app/routx-router'
import AlertsList from 'app/src/alerts/AlertsList'
import CreateAlertButton from 'app/src/alerts/CreateAlertButton'
import FeatGuarded from 'app/src/kit/FeatGuarded'
import HeaderActions from 'app/src/layouts/HeaderActions'

function Alerts() {
  const nav = useNavigate()
  const org = useOrgContext()

  return (
    <>
      <HeaderActions>
        <CreateAlertButton variant='small' onPress={() => nav('/alerts/create')} />
      </HeaderActions>
      <FeatGuarded org={org} feat={'FEAT-ALERT-GLOBAL'}>
        <AlertsList searchable />
      </FeatGuarded>
    </>
  )
}

export default Alerts

export const ErrorBoundary = () => null
